// Public VAPID key for Web Push subscriptions -- safe to ship in client JS,
// that's the whole point of VAPID's public/private split. The matching
// private key lives only in portalbackend/Backend/config.local.php (never
// committed). If you rotate the keypair, update both sides together --
// existing subscriptions created under the old key will fail silently.
export const VAPID_PUBLIC_KEY =
  'BN2OadjWDEgGwiLQEKSItfdUOItiymJcWYz4nFPxRcz0T99Hmtbvaj6_JIV-2S1EsRjFD_j-4eB8P0HoCZzlV10';
